// 工作台-问诊-主列表
export const consultColumns = [
  {
    title: '医生姓名',
    key: 'doctorName',
    width: 100,
    dataIndex: 'doctorName'
  },
  {
    title: '就诊人姓名',
    width: 140,
    dataIndex: 'patientProfileCommonVO',
    slots: {
      customRender: 'patientName'
    }
  },
  {
    title: '问诊状态',
    key: 'consultStatus',
    width: 100,
    dataIndex: 'consultStatus',
    slots: {
      customRender: 'consultStatus'
    }
  },
  {
    title: '问诊类型',
    key: 'consultType',
    dataIndex: 'consultType',
    width: 120,
    slots: {
      customRender: 'consultType'
    }
  },
  {
    title: '发起时间',
    key: 'startTime',
    dataIndex: 'startTime',
    width: 120
  },
  {
    title: '结束时间',
    key: 'evaluateTime',
    dataIndex: 'endTime',
    width: 120
  },
  {
    title: '问诊费',
    key: 'price',
    width: 200,
    dataIndex: 'priceString',
    slots: {
      customRender: 'priceString'
    }
  },
  {
    title: '支付状态',
    key: 'payStatus',
    width: 100,
    dataIndex: 'payStatus',
    slots: {
      customRender: 'payStatus'
    }
  },
  {
    title: '评价状态',
    key: 'evaluateStatus',
    dataIndex: 'evaluateStatus',
    width: 100,
    slots: {
      customRender: 'evaluateStatus'
    }
  },
  {
    title: '评价时间',
    key: 'evaluateTime',
    dataIndex: 'evaluateTime',
    width: 120
  },
  {
    title: '互联网医院',
    key: 'hospital',
    dataIndex: 'hospital',
    width: 160
  },
  {
    title: '问诊单号',
    key: 'id',
    dataIndex: 'id',
    width: 200
  },
  {
    title: '操作',
    key: 'score',
    fixed: 'right',
    dataIndex: 'score',
    width: 100,
    slots: {
      customRender: 'score'
    }
  }
]
